import React, { useContext, useMemo, useRef } from 'react';
import classnames from 'classnames';
import { useResizeObserver } from '../../../../utils/hooks/useResizeObserver';
import { useOnOutsideClick } from '../../../../utils/hooks/useOnOutsideClick';
import { PopupContext } from '../../../../Popup/PopupContext';
import noop from '../../../../utils/noop';
import { setRefs } from '../../../../utils/refHelpers';
import s from './PopoverContentWrapper.scss';
var PopoverContentWrapper = function (_a) {
    var arrow = _a.arrow, width = _a.width, height = _a.height, wrapperClassName = _a.wrapperClassName, contentClassName = _a.contentClassName, children = _a.children, innerRef = _a.innerRef, _b = _a.onResize, onResize = _b === void 0 ? noop : _b, _c = _a.onClickOutside, onClickOutside = _c === void 0 ? noop : _c;
    var contentRef = useRef(null);
    var isInPopup = useContext(PopupContext).isInPopup;
    useResizeObserver(contentRef, onResize);
    // ignore in-popup clicks if not inside one
    var outsideClickRoots = useMemo(function () { return (isInPopup ? contentRef : [contentRef, '.ReactModalPortal']); }, [isInPopup]);
    useOnOutsideClick(outsideClickRoots, function (e) { return onClickOutside(e); }, onClickOutside !== noop);
    return (React.createElement("div", { ref: function (node) { return setRefs([innerRef, contentRef], node); }, style: { width: width, height: height }, className: classnames(s['popper-wrapper'], wrapperClassName) },
        React.createElement("div", { className: classnames(s['popper-content'], height && s['with-scroll'], contentClassName), style: { width: width, height: height } }, children),
        arrow));
};
PopoverContentWrapper.displayName = 'PopoverContentWrapper';
export default PopoverContentWrapper;
//# sourceMappingURL=PopoverContentWrapper.js.map